import { setShellHint } from "@/components/custom/app-shell-skeleton";
import { experienceApi } from "./api";

type LogoutResponse = {
  logoutUrl: string;
};

export const logoutAndRedirect = async (): Promise<void> => {
  const { data } = await experienceApi.post<LogoutResponse>("/api/logout", {
    postLogoutRedirectUri: window.location.origin,
  });
  setShellHint(false);
  window.location.href = data.logoutUrl;
};
